const state = () => ({
  snackbar: false,
  snackbarMessage: "",
  snackbarTimeout: null
})
const getters = {
  isSnackbarShow(state) {
    return state.snackbar
  },
  getSnackbarMessage(state) {
    return state.snackbarMessage
  }
}
const mutations = {
  showSnackbar(state, message) {
    state.snackbar = true
    state.snackbarMessage = message
    clearTimeout(state.snackbarTimeout)
    state.snackbarTimeout = setTimeout(() => {
      state.snackbar = false
      state.snackbarMessage = ""
      state.snackbarTimeout = null
    }, 5000)
  },
  hideSnackbar(state) {
    state.snackbar = false
    state.snackbarMessage = ""
    clearTimeout(state.snackbarTimeout)
    state.snackbarTimeout = null
  }
}
const actions = {
  showSnackbar({ commit }, message) {
    commit("showSnackbar", message)
  },
  hideSnackbar({ commit }) {
    commit("hideSnackbar")
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
